
import clientAxios from "../client";

import { formatQueryString } from "@/common/utils/common";

import type { QueryType } from "@/common/types/common";
import type { PodcastType, PodcastPayloadType } from "@/common/types/podcast";

export async function podcastList(
    query?: QueryType
) {
    const queryString = formatQueryString(query);

    return await clientAxios.get(
        `podcast/list${queryString}`
    );
}

export async function podcastGet(
    podcast_id: string
) {
    return await clientAxios.get(
        `podcast/${podcast_id}/show`
    );
}

export async function podcastCreate(
    payload: PodcastPayloadType
) {
    return await clientAxios.post(
        `podcast/create`,
        payload
    );
}

export async function podcastPatch(
    podcast_id: string,
    payload: Partial<PodcastType>
) {
    return await clientAxios.patch(
        `podcast/${podcast_id}/patch`,
        { payload }
    );
}

export async function podcastDel(
    podcast_id: string,
) {
    return await clientAxios.del(
        `podcast/${podcast_id}/delete`,
    );
}
